<template>
  <div class="completed-homework-item">
    <div class="homework-item-top">
      <div class="homework-item-top-left-container">
        <div
          class="course-name"
          :style="{
            'background-color': $courseList[
              completedHomeworkItemData.courseName
            ]
              ? $courseList[completedHomeworkItemData.courseName].bgColor
              : $courseList['其他'].bgColor,
          }"
        >
          {{
            `${completedHomeworkItemData.studentName}的${completedHomeworkItemData.courseName}作业`
          }}
        </div>
      </div>
      <div class="homework-item-top-right-container">
        <div class="homework-review-status">
          <div
            class="status-indicator"
            :class="
              completedHomeworkItemData.status == '3'
                ? 'corrected'
                : 'uncorrected'
            "
          />
          <span
            class="status-text"
            :class="
              completedHomeworkItemData.status == '3'
                ? 'corrected'
                : 'uncorrected'
            "
            >{{
              completedHomeworkItemData.status == "3" ? "已批改" : "未批改"
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="homework-item-student-info">
      <div class="student-avatar">
        <el-image :src="completedHomeworkItemData.headPortrait" fit="cover">
          <div
            slot="error"
            class="image-slot"
            style="
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f5f7fa;
              color: #c0c4cc;
              font-size: 12px;
            "
          >
            <div>无图片</div>
          </div></el-image
        >
      </div>
      <div class="student-name">
        <i class="iconfont icon-student student-info-icon" /><span
          class="student-info-text"
          >{{ completedHomeworkItemData.studentName }}</span
        >
      </div>
      <div class="student-number">
        <i class="iconfont icon-student-number student-info-icon" /><span
          class="student-info-text"
          >{{ completedHomeworkItemData.studentNumber }}</span
        >
      </div>
    </div>
    <div class="homework-item-submit-time">
      <span class="time-label">提交时间:</span
      ><span class="time-value">{{
        completedHomeworkItemData.createTime
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    completedHomeworkItemData: {
      type: Object,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "./completedHomeworkItem.scss";
</style>